import { LANDSCAPE_BACKDROPS } from '../../../game/effects/atmosphere/silhouettes/landscapeBackdrops';
import { aridBiome } from '../biomeArchetypes';
import { ATMOSPHERE_PALETTE as P } from '../palette';

/** Desert — bright sun-bleached arid: a high sun + warm halo, hot god-ray shafts, drifting dust
 *  motes, a shimmering heat bed, blowing sand on the wind, ground heat-haze, layered lit dunes, and
 *  a sun-washed gold grade. The daytime-arid gap — warm GOLD, distinct from volcanic's dark ember red. */
export const DESERT = aridBiome({
  id: 'desert',
  sky: { from: 0x6fa6da, to: 0xe0b574 },
  celestial: { atX: 0.7, atY: 0.16, color: P.sunHaze, haloColor: 0xffe39a, size: 96, haloScale: 3.0, coreAlpha: 0.85, haloAlpha: 0.22 },
  raysBeforeMotes: true,
  motes: { colors: [P.sand, P.dune, P.sunHaze], alphaMax: 0.5 },
  rays: { color: P.sunHaze },
  glow: {
    blobs: [
      { color: P.sunHaze, atX: 0.7, atY: 0.14, size: 420, alpha: 0.08 },
      { color: P.dune, atX: 0.5, atY: 0.97, size: 600, alpha: 0.08 },
    ],
    breathe: { periodMs: 6000, min: 0.8, max: 1.25 },
  },
  lightField: { palette: [P.sunHaze, P.sand, P.dune] },
  weather: { mode: 'fall', color: P.sand, colorEnd: 0xe8c98a,
    gust: { periodMs: 8000, min: 0.5, max: 1.5, phase: 0.3 } },
  flicker: { color: P.sunHaze },
  extraLayers: [
    // Heat haze — rippling hot-air shimmer near the ground (the lensing distortion
    // of heated air over the desert floor). Subtle: low alpha, warm sand tint,
    // scale pulse reads as shimmer. Placed before the dune parallax so it sits
    // behind the foreground silhouettes.
    { kind: 'heatHaze', color: P.sunHaze, count: 7, sizeMin: 200, sizeMax: 380,
      alphaMin: 0.04, alphaMax: 0.11, bandYMin: 0.75, bandYMax: 0.98,
      driftPx: 20, periodMinMs: 3000, periodMaxMs: 5500 },
  ],
  parallax: [
    { svg: LANDSCAPE_BACKDROPS.desert.far, shape: 'dunes', color: 0xbd8f4e, speed: 0.04, height: 300, alpha: 0.72, detail: 0.7, sway: { ampPx: 8, periodMs: 30000 } },
    { svg: LANDSCAPE_BACKDROPS.desert.mid, shape: 'dunes', color: 0x9c6f38, speed: 0.10, height: 220, alpha: 0.86, detail: 1.0 },
    { svg: LANDSCAPE_BACKDROPS.desert.near, shape: 'dunes', color: 0x7a5128, speed: 0.18, height: 150, alpha: 0.95, detail: 1.1 },
  ],
  closer: {
    vignette: { color: 0x6b4a22, edgeAlpha: 0.3, washColor: 0xffc04a, washAlpha: 0.05 },
    grade: { top: 0xffcf7a, bottom: 0xb87a32, strength: 0.1, blend: 'normal' },
  },
});
